import React, { useState } from "react";
import {
  dropdownButtonStyles,
  dropdownSizeStyles,
  dropdownMenuStyles,
  menuWidthStyles,
  optionStyles,
} from ".././utils/css/baseStyles";
import { DropdownProps } from "./ComponentProps";
const Dropdown: React.FC<DropdownProps> = ({
  size,
  options,
  icon,
  buttonText,
  onOptionSelect,
  styles,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option: any) => {
    console.log("bbb", option);
    setIsOpen(false);
    onOptionSelect(option);
  };

  return (
    <div className="relative inline-block" style={styles || undefined}>
      <button
        onClick={toggleDropdown}
        className={`${dropdownButtonStyles} ${dropdownSizeStyles[size]}`}
      >
        <div className="flex gap-2 items-center">
          {icon && <div>{icon}</div>}
          <div>{buttonText}</div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`w-5 h-5 transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className={`${dropdownMenuStyles} ${menuWidthStyles[size]}`}>
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => handleOptionSelect(option)}
              className={`flex items-center justify-center text-center p-2 w-full ${optionStyles}`}
            >
              {option.icon && <div>{option.icon}</div>}
              <span className="whitespace-normal break-words text-center block w-full leading-tight">
                {option.label}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

Dropdown.defaultProps = {
  size: "medium",
  options: [],
  icon: null,
  buttonText: "Dropdown",
  onOptionSelect: () => {},
};

export default Dropdown;
